/* tslint:disable */
/* eslint-disable */
/**
 * data-center
 * data-center
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OmniGenerateIFrameUrlResponse } from './OmniGenerateIFrameUrlResponse';
import {
    OmniGenerateIFrameUrlResponseFromJSON,
    OmniGenerateIFrameUrlResponseFromJSONTyped,
    OmniGenerateIFrameUrlResponseToJSON,
    OmniGenerateIFrameUrlResponseToJSONTyped,
} from './OmniGenerateIFrameUrlResponse';

/**
 * 
 * @export
 * @interface OmniGenerateIFrameUrl201Response
 */
export interface OmniGenerateIFrameUrl201Response {
    /**
     * 
     */
    data?: OmniGenerateIFrameUrlResponse;
}

/**
 * Check if a given object implements the OmniGenerateIFrameUrl201Response interface.
 */
export function instanceOfOmniGenerateIFrameUrl201Response(value: object): value is OmniGenerateIFrameUrl201Response {
    return true;
}

export function OmniGenerateIFrameUrl201ResponseFromJSON(json: any): OmniGenerateIFrameUrl201Response {
    return OmniGenerateIFrameUrl201ResponseFromJSONTyped(json, false);
}

export function OmniGenerateIFrameUrl201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OmniGenerateIFrameUrl201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : OmniGenerateIFrameUrlResponseFromJSON(json['data']),
    };
}

export function OmniGenerateIFrameUrl201ResponseToJSON(json: any): OmniGenerateIFrameUrl201Response {
    return OmniGenerateIFrameUrl201ResponseToJSONTyped(json, false);
}

export function OmniGenerateIFrameUrl201ResponseToJSONTyped(value?: OmniGenerateIFrameUrl201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': OmniGenerateIFrameUrlResponseToJSON(value['data']),
    };
}

